// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"f942b6ea","361":"a3cc8b06","767":"3ed10a3d"}[chunkId] + ".chunk.js";
};